<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM LỚP HỌC BỔ TRỢ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" flat class="pa-6">
        <v-row>
          <v-col cols="12" md="6" class="pb-0">
            <AutocompleteSubject
              v-model="subject"
              label="Môn học"
              return-object
              placeholder="Chọn môn học"
              outlined
              dense
              class="required"
              :filter="filterSubject"
              :rules="[$rules.required]"
              @change="subjectChanged"
            />
          </v-col>
          <v-col cols="12" md="6" class="pb-0">
            <AutocompleteGrade :disabled="disabled" v-model="grade" label="Học phần" dense outlined />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              ref="title"
              v-model="title"
              label="Tên lớp"
              outlined
              required
              dense
              class="required"
              :rules="[$rules.required]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-textarea ref="description" v-model="description" label="Mô Tả" hide-details outlined />
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import get from 'lodash-es/get'
import { Class, Teaching } from '@/plugins/api'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteSubject,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      description: '',
      title: '',
      teacher: null,
      division: null,
      grade: null,
      subject: null,
      disabled: false,
    }
  },
  computed: {
    filterSubject() {
      return { type: 'extraCurriculum' }
    },
  },
  methods: {
    ...mapActions('class', ['createClass']),
    subjectChanged(subject) {
      const grade = get(subject, 'grade')
      if (grade && grade.id) {
        this.disabled = true
      } else {
        this.disabled = false
      }
      this.grade = grade
    },
    gradeChanged() {},
    async save() {
      if (!this.$refs.form.validate()) return
      const data = {
        grade: get(this.grade, 'id'),
        extraSubject: get(this.subject, 'id'),
        title: this.title,
        description: this.description,
      }
      let classData = {}
      try {
        this.$loading.active = true
        classData = await this.createClass({
          ...data,
          status: 'running',
          type: 'extraCurriculum',
        })

        // tạo giảng dạy
        await Teaching.create({
          class: classData.id,
          grade: get(classData, 'grade.id'),
          subject: classData.extraSubject.id,
          subjectGroup: get(classData.extraSubject, 'subjectGroup'),
        })

        this.$alert.addSuccess()
        this.$refs.form.reset()
        this.dialog = false
        this.$emit('done', classData)
      } catch (error) {
        this.$alert.addError()
        await Class.remove(get(classData, 'id'))
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
  },

  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
